<script setup>
import axios from 'axios'
import { ref, onMounted } from 'vue'

axios.defaults.headers.common = {
  'X-Requested-With': 'XMLHttpRequest',
};

const standing = ref()
const date = ref("")
const getData = async() => {
  await axios.get("./php/getStanding.php")
  .then((response) => {
    standing.value = response.data.standing
    date.value     = response.data.date
  })
}

onMounted(() => {
  getData()
})
</script>

<template>
  <h5>順位表</h5>
  <table>
    <thead>
      <tr>
        <th colspan="2"></th>
        <th>試</th>
        <th>勝</th>
        <th>敗</th>
        <th>分</th>
        <th>差</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="team in standing" :key="team.rank" :class="{'css__tr-eagles' : team.id == 1}">
        <td>{{ team.rank }}</td>
        <td class="border">
          <img v-if="team.name != ''" decoding="async" class="petmark" :src="require('../../assets/' + team.name + '.png')" :alt="team.name">
        </td>
        <td class="border">{{ team.games }}</td>
        <td class="border">{{ team.win }}</td>
        <td class="border">{{ team.lose }}</td>
        <td class="border">{{ team.draw }}</td>
        <td>{{ team.gb }}</td>
      </tr>
    </tbody>
  </table>
  <p>{{ date }}時点</p>
</template>

<style scoped>
  table {
    width: 100%;
  }

  tr.css__tr-eagles {
    background: rgba(250, 255, 179, .8);
  }

  th, td {
    text-align: center;
    padding: .15em;
    font-size: .85em;
  }

  th:not(:last-child),
  td.border {
    border-right: 1px solid rgba(0, 0, 0, .05);
  }

  img {
    width: 1.5em;
  }
</style>